import React, { Fragment, useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Button,
  Divider,
} from "@material-ui/core";

import InfoIcon from "@material-ui/icons/Info";
import { palette } from "../../../../configurations/styles/theme";

const useStyles = makeStyles((theme) => ({
  IconButton: {
    marginTop: "0%",
    marginBottom: "0%",
    padding: "0px",
  },
  containderInfoUser: {
    fontSize: "15px",
    padding: "2%",
    borderTopWidth: "0px",
    borderLeftWidth: "0px",
    borderRightWidth: "0px",
    marginTop: "0.5%",
    color: "#919191",
  },
  containerInfoCompany: {
    // borderStyle: 'solid',
    //backgroundColor: palette.info.light,
    //borderRadius: '3px',
    fontSize: "15px",
    padding: "2%",
    borderTopWidth: "0px",
    borderLeftWidth: "0px",
    borderRightWidth: "0px",
    // borderBottomWidth: '1px',
    marginTop: "0.5%",
    marginRight: "2%",
    color: "#919191",
  },
  buttonClose: {
    margin: "2%",
  },
  infoTitle: {
    color: "#001038",
    fontWeight: 400,
  },
}));
const InfoCompanyBtn = ({ company }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <IconButton
        color="primary"
        aria-label="upload picture"
        component="span"
        onClick={handleClickOpen}
        className={classes.IconButton}
      >
        <InfoIcon style={{ color: palette.primary.main }} />
      </IconButton>
      <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
        <DialogTitle id="max-width-dialog-title">
          Información adicional de la empresa
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={2} className={classes.infoTitle}>
              RUC:
            </Grid>
            <Grid
              item
              md={3}
              className={classes.containerInfoCompany}
              align="center"
            >
              {company.idempresacontratante}
            </Grid>
            <Grid item md={3} className={classes.infoTitle}>
              Razón Social:
            </Grid>
            <Grid
              item
              md={3}
              className={classes.containerInfoCompany}
              align="center"
            >
              {company.razonSocialempresa}
            </Grid>
            <Grid item md={2} className={classes.infoTitle}>
              Correo:
            </Grid>
            <Grid
              item
              md={3}
              className={classes.containerInfoCompany}
              align="center"
            >
              {company.correo}
            </Grid>
            <Grid item md={3} className={classes.infoTitle}>
              Fecha de registro:
            </Grid>
            <Grid item md={3} className={classes.containerInfoCompany}>
              {company.fechaRegistro.substring(0, 10)}
            </Grid>
            <Grid item md={3} className={classes.infoTitle}>
              # Comprobantes Emitidos:
            </Grid>
            <Grid item md={2} className={classes.containderInfoUser}>
              {company.comprobantesUtilizados}
            </Grid>
            <Grid item md={3} align="center" className={classes.infoTitle}>
              # Comprobantes Disponibles
            </Grid>
            <Grid
              item
              md={3}
              className={classes.containerInfoCompany}
              align="center"
            >
              {company.comprobantesDisponibles}
            </Grid>
            <Grid item md={12} align="center">
              <Divider></Divider>
            </Grid>
            <Grid item md={12} align="center" style={{ padding: "0px" }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                className={classes.buttonClose}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default InfoCompanyBtn;
